import khMessages from '../locales/km_KH';

const KhLang = {
  messages: {
    ...khMessages,
  },
  locale: 'km-KH',
};
export default KhLang;
